{
  "w": 8,
  "h": 12,
  "rows": [
    "....G...",
    "...WWW..",
    "....G...",
    "...WGW..",
    "...WWW..",
    "...GGG..",
    "...GGG..",
    "...RR...",
    "...RR...",
    "...RR...",
    "...RR...",
    "...WWW.."
  ],
  "legend": {
    "G": "C.B_GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
